import React, { useEffect, useState } from 'react'
import { fetchFerryService } from 'services'
import { useErrorHandling } from 'context/errorHandling'
import { DetailsColumn, DetailsRow, TitleBar } from 'components/Shared/CrudComponents'
import { useHistory } from 'react-router-dom'
import { ReadOnlyTextField } from 'components/Shared/ReadOnlyTextField'
import { Loader } from 'components/Shared/Loader'
import { fetchContractor } from 'services/ContractorService'
import { toFerryValues } from 'components/FerryServices/FerryServiceForm/form'
import Sections from 'components/FerryServices/sections'
import Module from 'constants/customFieldModules'
import { CustomFieldsProvider } from 'context/customFields'
import {
  FERRY_SERVICE_ADDITIONAL_DATA_READ,
  FERRY_SERVICE_CONTRACTOR_READ,
  FERRY_SERVICE_DATA_READ,
  FERRY_SERVICE_EDIT,
  useAuth
} from 'context/auth'
import { useTranslation } from 'react-i18next'

export function FerryServiceDetails (props) {
  const ferryServiceId = props.match.params.id

  const [ferryService, setFerryService] = useState()
  const [contractor, setContractor] = useState()
  const [loading, setLoading] = useState(false)

  const { handleError } = useErrorHandling()
  const { hasAnyPrivileges } = useAuth()
  const history = useHistory()
  const { t } = useTranslation()

  const hasContractorReadPrivileges = hasAnyPrivileges([FERRY_SERVICE_CONTRACTOR_READ])

  useEffect(() => {
      setLoading(true)
      fetchFerryService(ferryServiceId)
        .then(ferryServiceResponse => {
          setFerryService(toFerryValues(ferryServiceResponse))
          return hasContractorReadPrivileges ?
            fetchContractor(ferryServiceResponse.contractorId)
            : Promise.resolve(null)
        })
        .then(setContractor)
        .catch(handleError)
        .then(() => setLoading(false))
    }, [ferryServiceId, hasContractorReadPrivileges, handleError]
  )

  const handleEditButtonClick = () => {
    history.push(`/ferry-services/edit/${ferryServiceId}`)
  }

  const hasFerryServiceDataReadPrivilege = hasAnyPrivileges([FERRY_SERVICE_DATA_READ])

  const title = hasFerryServiceDataReadPrivilege && ferryService
    ? `${ferryService.startLocation.text} - ${ferryService.endLocation.text}`
    : t('ferryServices.details.title')

  return (
    <>
      <TitleBar
        title={title}
        buttonLabel="ferryServices.details.editButton"
        onButtonClick={handleEditButtonClick}
        isButtonDisabled={!hasAnyPrivileges([FERRY_SERVICE_EDIT])}
      />
      <CustomFieldsProvider module={Module.FerryServices} entityId={ferryServiceId}>
        <DetailsRow>
          <DetailsColumn section={Sections.Contractor} visible={hasAnyPrivileges([FERRY_SERVICE_CONTRACTOR_READ])}>
            <ReadOnlyTextField label="ferryServices.details.fields.contractor"
                               value={contractor?.shortName}/>
          </DetailsColumn>
          <DetailsColumn section={Sections.BasicDetails} visible={hasFerryServiceDataReadPrivilege}>
            <ReadOnlyTextField label="ferryServices.details.fields.startLocation"
                               value={ferryService?.startLocation?.text}/>
            <ReadOnlyTextField label="ferryServices.details.fields.endLocation"
                               value={ferryService?.endLocation?.text}/>
            <ReadOnlyTextField label="ferryServices.details.fields.type"
                               value={ferryService?.type}/>
            <ReadOnlyTextField label="ferryServices.details.fields.price"
                               value={ferryService?.price}/>
            <ReadOnlyTextField label="ferryServices.details.fields.currencyCode"
                               value={ferryService?.currencyCode}/>
            <ReadOnlyTextField label="ferryServices.details.fields.bunkerAdjustmentFactor"
                               value={ferryService?.bunkerAdjustmentFactor}/>
            <ReadOnlyTextField label="ferryServices.details.fields.harbourLocation"
                               value={ferryService?.harbourLocation}/>
          </DetailsColumn>
          <DetailsColumn section={Sections.AdditionalData}
                         visible={hasAnyPrivileges([FERRY_SERVICE_ADDITIONAL_DATA_READ])}>
            <ReadOnlyTextField label="ferryServices.details.fields.additionalInfo"
                               value={ferryService?.additionalInfo}/>
          </DetailsColumn>
        </DetailsRow>
      </CustomFieldsProvider>
      {loading && <Loader/>}
    </>
  )
}
